<template>
  <!-- eslint-disable -->
  <b-sidebar
    id="add-new-inventory-item"
    :visible="isAdd"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    no-close-on-backdrop
    @change="(val) => $emit('update:is-add', val)"
  >
    <template #default="{ hide }">
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">Mover a inventario</h5>
        <feather-icon class="ml-1 cursor-pointer" icon="XIcon" size="16" @click="[hide(), resetForm()]" />
      </div>

      <validation-observer #default="{ invalid }" ref="refFormObserver">
        <b-form class="p-2" @submit.prevent="onSubmit">
          <validation-provider #default="{ errors }" name="Warehouse" rules="requeridoE">
            <b-form-group label="Warehouse" label-for="warehouse">
              <b-form-input
                id="warehouse"
                v-model="form.warehouse"
                trim
                placeholder="Warehouse"
                :class="errors.length > 0 ? 'is-invalid' : null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>

          <validation-provider #default="{ errors }" name="Fila" rules="requeridoE">
            <b-form-group label="Fila" label-for="fila">
              <b-form-input
                id="fila"
                v-model="form.fila"
                trim
                placeholder="FILA-A"
                :class="errors.length > 0 ? 'is-invalid' : null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>

          <validation-provider #default="{ errors }" name="Bloque" rules="requeridoE">
            <b-form-group label="Bloque" label-for="bloque">
              <b-form-input
                id="bloque"
                v-model="form.bloque"
                trim
                placeholder="BLOQUE-1"
                :class="errors.length > 0 ? 'is-invalid' : null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>

          <div class="d-flex justify-content-between align-items-center mt-2 mb-1">
            <h6 class="mb-0">Items</h6>
            <b-button variant="outline-primary" size="sm" @click="addRow">
              <feather-icon icon="PlusIcon" class="mr-50" />
              Agregar item
            </b-button>
          </div>

          <b-alert v-if="validationMessage" show variant="danger" class="mb-1">
            {{ validationMessage }}
          </b-alert>

          <div class="inventory-items">
            <div v-for="(detail, index) in details" :key="index" class="inventory-item-row">
              <b-row>
                <b-col cols="12" class="d-flex justify-content-between align-items-center mb-75">
                  <span class="font-weight-bold">Item {{ index + 1 }}</span>
                  <b-button
                    size="sm"
                    variant="flat-danger"
                    :disabled="details.length === 1"
                    v-b-tooltip.hover.top="'Eliminar'"
                    @click.prevent="removeRow(index)"
                  >
                    <feather-icon icon="Trash2Icon" />
                  </b-button>
                </b-col>
                <b-col cols="12" class="mb-1">
                  <label>Marca</label>
                  <b-form-input v-model="detail.brand" placeholder="TYM" />
                </b-col>
                <b-col cols="12" class="mb-1">
                  <label>Codigo</label>
                  <b-form-input v-model="detail.code" placeholder="888999" />
                </b-col>
                <b-col cols="12">
                  <label>Cantidad</label>
                  <b-form-input v-model.number="detail.qty" type="number" min="1" placeholder="2" />
                </b-col>
              </b-row>
            </div>
          </div>

          <div class="d-flex mt-2 justify-content-end">
            <b-button
              :disabled="invalid"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="success"
              class="mr-2"
              type="submit"
            >
              Mover a inventario
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              variant="outline-secondary"
              @click="[hide(), resetForm()]"
            >
              Cancel
            </b-button>
          </div>
        </b-form>
      </validation-observer>
    </template>
  </b-sidebar>
</template>

<script>
/* eslint-disable */
import Vue from 'vue'
import { BootstrapVue, VBTooltip } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { required } from '@validations'
import { ValidationProvider, ValidationObserver } from 'vee-validate'

Vue.use(BootstrapVue)

export default {
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    isAdd: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      required,
      validationMessage: '',
      form: {
        warehouse: '',
        fila: '',
        bloque: '',
      },
      details: [this.emptyItem()],
    }
  },
  methods: {
    emptyItem() {
      return {
        brand: '',
        code: '',
        qty: null,
      }
    },
    addRow() {
      this.details.push(this.emptyItem())
    },
    removeRow(index) {
      if (this.details.length === 1) return
      this.details.splice(index, 1)
    },
    resetForm() {
      if (this.$refs.refFormObserver) this.$refs.refFormObserver.reset()
      this.validationMessage = ''
      this.form = {
        warehouse: '',
        fila: '',
        bloque: '',
      }
      this.details = [this.emptyItem()]
    },
    buildPayload() {
      return {
        warehouse: String(this.form.warehouse).trim(),
        fila: String(this.form.fila).trim(),
        bloque: String(this.form.bloque).trim(),
        detail: this.details.map(item => ({
          brand: String(item.brand).trim(),
          code: String(item.code).trim(),
          qty: Number(item.qty),
        })),
      }
    },
    validDetails(payload) {
      return payload.detail.every(item => item.brand && item.code && Number(item.qty) > 0)
    },
    onSubmit() {
      this.$refs.refFormObserver.validate().then(success => {
        const payload = this.buildPayload()

        if (!success || !this.validDetails(payload)) {
          this.validationMessage = 'Completa marca, codigo y cantidad mayor a 0 en todos los items.'
          return
        }

        this.validationMessage = ''
        this.$emit('saved', payload)
        this.$emit('update:is-add', false)
        this.resetForm()
      })
    },
  },
}
</script>

<style scoped>
.inventory-items {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.inventory-item-row {
  border: 1px solid #ebe9f1;
  border-radius: 0.357rem;
  padding: 1rem;
  background-color: #fff;
}
</style>
